var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialsVoteModalLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#363B4D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 13.3333L16.4 12.4L14.6667 14.1333L14.6667 7.33334L13.3333 7.33334L13.3333 14.1333L11.6 12.4L10.6667 13.3333L14 16.6667L17.3333 13.3333ZM9.33333 19.3333L9.33333 14L8 14L8 19.3333C8 20.0667 8.6 20.6667 9.33333 20.6667L18.6667 20.6667C19.4 20.6667 20 20.0667 20 19.3333L20 14L18.6667 14L18.6667 19.3333L9.33333 19.3333Z",
    fill: "#363B4D",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsVoteModalLoadIcon);
export default __webpack_public_path__ + "static/media/Materials_vote_modal_load_icon.99c745dceb3cb95d1783f89d40bdf9b3.svg";
export { ForwardRef as ReactComponent };